<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content [innerHtml]="data.content | markdown" class="dialog-content"> </mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button [mat-dialog-close]="true">{{ data.okButtonLabel }}</button>
  <button mat-stroked-button mat-dialog-close>{{ data.cancelButtonLabel }}</button>
</mat-dialog-actions>
